import axios from 'axios'
import { deepFreeze,  QS_CONFIG } from '../../../features/common/Utilities'
import { sanitizeData, setBottomRightInfo } from './getAuto'
import qs from 'query-string'
import { parsedSearch } from 'BFF/utils/utils'
import { CATALOGO_ENDPOINT } from 'common/endpoints'

export async function getPaginatedListVistaVendedor({ search, cancelToken, refreshCache }) {
  const parsedQuery = parsedSearch(search)
  if(parsedQuery?.tipo === 'usado')  delete parsedQuery['stockDisponible']

  if (refreshCache) {
    parsedQuery.refreshCache = true
  }

  const newSearch = qs.stringify(parsedQuery, QS_CONFIG)

  const results = await axios
    .get(`${CATALOGO_ENDPOINT}/catalogFlatSearchInternal/?${newSearch}`, {
      cancelToken,
    })
    .then(res => res.data)
    .then(res => {
      res.data.forEach(sanitizeData)
      return res
    })

  results.data = results.data.filter((auto) => auto)
  results.data.forEach((auto) => {
    setBottomRightInfo(auto)
    auto.title = `${auto.brand} ${auto.model} ${auto.version}`
    auto.breadCrumbLabel = auto.title
  })

  return deepFreeze(results)
}
